import { HeroProps } from "@/src/sections/hero/v1";

export const heroData_en: HeroProps = {
  items: [
    {
      image: {
        src: "/assets/images/hero/Bone.webp",
        alt: "hero 1",
      },
      title: "a world where you are the center",
      button: {
        label: "Discover More",
        href: "/",
      },
    },
    {
      image: {
        src: "/assets/images/hero/Bthree.webp",
        alt: "hero 1",
      },
      title: "Empowering Your Digital Future",
      button: {
        label: "Discover More",
        href: "/",
      },
    },
    {
      image: {
        src: "/assets/images/hero/Btwo.webp",
        alt: "hero 1",
      },
      title: "Dedicated to innovation and cybersecurity",
      button: {
        label: "Discover More",
        href: "/",
      },
    },
  ],
};
